import { TagApiError } from '../utils/analytics-tagging';
import { ReturnEligibilityAPI } from '../api/returns';
export var GetReturnsEligibilityDetails = function (requestData, setReturnEligibilityDetails, setAlertState) {
    return ReturnEligibilityAPI(requestData)
        .then(function (response) {
        setAlertState(null);
        setReturnEligibilityDetails(response.data);
        return response.data;
    })
        .catch(function (error) {
        var _a;
        var isNetworkError = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500 ||
            (error === null || error === void 0 ? void 0 : error.code) === 'ERR_NETWORK' ||
            (error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED';
        TagApiError(error);
        if (isNetworkError) {
            setAlertState({
                type: 'NETWORK',
                status: 'error',
            });
            throw new Error('NETWORK');
        }
        setAlertState({
            type: 'GENERIC',
            status: 'error',
        });
        throw new Error('GENERIC');
    });
};
